import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import type { FeedUnit } from '@interfaces/homepage';
import type { User } from '@utils/backend-api/currentUser';

import MyTIContent from './Content';

const queryClient = new QueryClient();

interface MyTIProps {
  env: Record<string, string>;
  forumPosts: FeedUnit;
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  isWebview: boolean;
}

const MyTI = ({ env, forumPosts, initialCurrentUser, isGdprRequired, isWebview }: MyTIProps) => {
  return (
    <AppContextProvider
      env={env}
      initialCurrentUser={initialCurrentUser}
      isGdprRequired={isGdprRequired}
      isWebview={isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <MyTIContent forumPosts={forumPosts} initialCurrentUser={initialCurrentUser} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default MyTI;
